import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY, APP_PREFIX_PATH } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token } = useSelector(state => state.auth)
	const location = useLocation()
	const searchParams = new URLSearchParams(location.search)
	const redirectParam = searchParams.get('redirect');

	//This will allow us to land on fcadmin-login EVEN if a user is logged in.
	if (location.pathname.indexOf('fcadmin-login') > -1) {
		return <Outlet/>
	}

	// If a logged-in user hits the public cert lookup link, send them to the
	// authenticated dashboard lookup view instead, preserving the e-rec-id query.
	if (token && location.pathname.includes('/public/lookup')) {
		return <Navigate to={`${APP_PREFIX_PATH}/dashboard/lookup${location.search}`} replace />;
	}

	return token
		? <Navigate to={redirectParam || AUTHENTICATED_ENTRY} replace />
		: <Outlet/>
}

export default PublicRoute